<template>
	<div>
		<div>二维码</div>
		<div id="login_container" style="text-align: center;"></div>
		<p>{{str}}</p>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				str: encodeURIComponent('http://h5.freshin.com/weixin/callback')
			};
		},
		mounted: function() {
			var obj = new WxLogin({
				self_redirect: false,
				id: "login_container",
				appid: "wx572b220968da638c",
				scope: "snsapi_login",
				redirect_uri: encodeURIComponent('http://h5.freshin.com/weixin/callback'),
				// redirect_uri: encodeURIComponent(windows),
				state: Math.ceil(Math.random() * 1000),
				style: "black",
				href: ""
			});
		},

		methods: {
		}

	};
</script>

<style>

</style>



// WEBPACK FOOTER //
// index.vue?f8c83804